import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { InfoUsuarioService } from './info-usuario.service';

@Injectable({
  providedIn: 'root'
})
export class ErroresService {

  constructor(private snackBar: MatSnackBar, private router: Router, private infoUsuarioService: InfoUsuarioService) { }

  MostrarErrorSistema(Mensaje: string): void
  {
    this.snackBar.open(Mensaje, 'ok', {
      verticalPosition: 'top',
      panelClass: ['snackBarError500']
    });
  }

  async MostrarErrorByStatus(err: any, mensajeErrorSistema = ""): Promise<void>
  {
    if (err.status === 0)
    {
      this.MostrarErrorSistema('No es posible conectar con el servidor');
    }
    else if (err.status === 401)
    {
      // Reviso si el error 401 (Unauthorized) es debido a que se vencio la session o a que el usuario no tiene permisos
      if (err._body === "")
      {
        // Es debido a que se venció la session
        await this.infoUsuarioService.CerrarSesion();
        this.router.navigate(['/login']);
      }
      else
      {
        // Es debido a que el usuario no tiene permisos
        this.MostrarErrorSistema('No tiene permisos para la operación solicitada');
      }
    }
    else
    {
      if (mensajeErrorSistema === '')
      {
        mensajeErrorSistema = 'Error de sistema';
      }
      this.MostrarErrorSistema(mensajeErrorSistema);
    }
  }

  public MostrarError400(error: any): string
  {
    let mensaje = "Ocurrió un error inesperado. Verifique la información enviada";

    if (error.error["codigoExistente"] != null)
    {
      mensaje = error.error["codigoExistente"];
    }
    else if (error.error["PeriodoInvalido"] != null)
    {
      mensaje = error.error["PeriodoInvalido"];
    }
    else if (error.error["EntidadRelacionada"] != null)
    {
      mensaje = error.error["EntidadRelacionada"];
    }
    else if (error.error["UsuarioNoTienePermisos"] != null)
    {
      mensaje = error.error["UsuarioNoTienePermisos"];
    }
    else if (error.error[50] != null)
    {
      //NO_DATA = 50;
      mensaje = error.error[50];
    }
    else if (error.error[60] != null)
    {
      //NO_VALID_DATA = 60;
      mensaje = error.error[60];
    }
    else if (error.error[70] != null)
    {
      //NO_VALID_PERIOD = 70;
      mensaje = error.error[70];
    }

    return mensaje;
  }
}
